export function getSentryConfig() {
    // Detectar si estamos en Vite (cliente) o Node.js (servidor)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isVite = typeof import.meta !== "undefined" && import.meta.env;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const env = isVite ? import.meta.env : process.env;
    // En Vite, las variables de entorno deben tener prefijo VITE_
    const dsn = isVite
        ? env.VITE_SENTRY_DSN ?? ""
        : env.SENTRY_DSN ?? "";
    const environment = isVite
        ? env.VITE_SENTRY_ENVIRONMENT ?? env.MODE ?? "development"
        : env.SENTRY_ENVIRONMENT ?? env.NODE_ENV ?? "development";
    const nodeEnv = isVite
        ? env.MODE ?? "development"
        : env.NODE_ENV ?? "development";
    const enabled = Boolean(dsn && nodeEnv === "production");
    return {
        dsn,
        environment,
        enabled,
        tracesSampleRate: enabled ? 0.1 : 0,
        profilesSampleRate: enabled ? 0.1 : 0,
        release: isVite
            ? env.VITE_SENTRY_RELEASE
            : env.SENTRY_RELEASE,
    };
}
//# sourceMappingURL=config.js.map